import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgNew = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M9.54 14.467v-4.465H8.496v1.82c0 .289.006.53.013.634h-.013a6 6 0 0 0-.271-.555l-1.073-1.899H6.16v4.465h1.042v-1.912c0-.194-.005-.381-.01-.5l-.002-.117h.012l.003.007c.038.09.124.29.269.548l1.11 1.974zm3.097 0v-1.024h-1.233v-.71h1.085v-.998h-1.085v-.71h1.233v-1.023h-2.442v4.465zm4.627-4.465h1.245l-1.079 4.465h-1.178l-.42-1.974c-.06-.27-.09-.517-.109-.666l-.001-.012h-.012l-.01.066c-.022.163-.047.352-.101.612l-.42 1.974h-1.178l-1.079-4.465h1.246l.382 2.325c.037.234.062.42.08.598h.013c.012-.123.037-.364.086-.598l.487-2.325h1l.486 2.325c.044.222.074.456.087.598h.012l.01-.079c.015-.137.034-.298.07-.52z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgNew;
